export const menuItemX = '100vw';
export const boxX = '120vw';
